{
  "point": "балл",
  "points": "баллы",
  "credits": "кредиты",
  "loyaltyCredit": "Кредит лояльности",
  "statusPoints": "Статусные баллы",
  "balancePoints": "Расходные баллы",
  "edit": "Редактировать",
  "delete": "Удалить",
  "copyOf": "Копия {value}",
  "numberedCopyOf": "Копия {index} из {value}",
  "total": "всего",
  "uplift": "прирост",
  "approveBtn.label": "ОК",
  "cancelBtn.label": "Отменить",
  "createBtn.label": "Создать",
  "saveBtn.label": "Сохранить",
  "searchBtn.label": "Поиск",
  "updateBtn.label": "Обновить",
  "applyBtn.label": "Применить",
  "addNewPlanBtn.label": "Добавить план",
  "launchPlanBtn.label": "Запустить план",
  "toOverviewBtn.label": "Перейти к обзору",
  "collapseBtn.label": "Свернуть",
  "extendBtn.label": "Сведения ",
  "updateAndSave.label": "Обновить и сохранить",
  "pleaseConfirmBtn.label": "Подтвердить",
  "closeBtn.label": "Закрыть",
  "resetBtn.label": "Сбросить",
  "confirmBtn.label": "Подтвердить",
  "status.inactive": "Неактивно",
  "status.active": "Активно",
  "status.deactivated": "Деактивировано",
  "status.scheduled": "Запланировано",
  "status.expired": "Срок действия истек",
  "status.readyToUse": "Готово к использованию",
  "status.readyToLaunch": "Готово к запуску",
  "status.empty": "Пусто",
  "status.activity.pending": "Ожидается",
  "status.activity.confirmed": "Подтверждено",
  "status.activity.expired": "Срок действия истек",
  "status.activity.canceled": "Отменено",
  "status.activity.removed": "Удалено",
  "status.default": "По умолчанию",
  "action.promotion": "Промоакция",
  "action.referral": "Рекомендация",
  "action.action": "Акция",
  "tiers.numberOfPurchases.plural.zero": "{number} покупка",
  "tiers.numberOfPurchases.plural.one": "{number} покупка",
  "tiers.numberOfPurchases.plural.two": "{number} покупка",
  "tiers.numberOfPurchases.plural.few": "{number} покупка",
  "tiers.numberOfPurchases.plural.many": "{number} покупка",
  "tiers.numberOfPurchases.plural.other": "{number} покупка",
  "validity.unlimited": "Без ограничений",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} дн.",
  "validity.limitedFromEarn.value.days.plural.one": "{number} день",
  "validity.limitedFromEarn.value.days.plural.two": "{number} дн.",
  "validity.limitedFromEarn.value.days.plural.few": "{number} дн.",
  "validity.limitedFromEarn.value.days.plural.many": "{number} дн.",
  "validity.limitedFromEarn.value.days.plural.other": "{number} дн.",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} нед.",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} неделя",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} нед.",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} нед.",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} нед.",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} нед.",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} мес.",
  "validity.limitedFromEarn.value.months.plural.one": "{number} месяц",
  "validity.limitedFromEarn.value.months.plural.two": "{number} мес.",
  "validity.limitedFromEarn.value.months.plural.few": "{number} мес.",
  "validity.limitedFromEarn.value.months.plural.many": "{number} мес.",
  "validity.limitedFromEarn.value.months.plural.other": "{number} мес.",
  "days": "Дни",
  "dayInMonth": "День",
  "month": "Месяц",
  "months.1": "Январь",
  "months.2": "Февраль",
  "months.3": "Март",
  "months.4": "Апрель",
  "months.5": "Май",
  "months.6": "Июнь",
  "months.7": "Июль",
  "months.8": "Август",
  "months.9": "Сентябрь",
  "months.10": "Октябрь",
  "months.11": "Ноябрь",
  "months.12": "Декабрь",
  "form.missingSettingsAlert": "Прежде чем сохранить и перейти к следующему шагу, убедитесь, что введена вся требуемая информация.",
  "noResults.title": "Результаты не найдены.",
  "noResults.text": "Нет результатов, отвечающих вашему поисковому запросу \"{text}\".",
  "alertContainer.editModeAlert.message": "Вы работаете над редактированием следующей версии плана лояльности. Ваши изменения вступят в силу после запуска этой новой версии. ",
  "alertContainer.liveModeAlert.message.linkText": "Узнать больше",
  "alertContainer.liveModeAlert.message": "Чтобы изменить уровни, фиксированные и дополнительные льготы, на вкладке \"Управление лояльностью\" выберите \"Обновить и запустить\", а затем переключитесь на редактирование следующей версии. {link}",
  "card.isRoadmap.text": "Маршрутная карта",
  "catalogSelector.tooManyResults.title": "Поиск вернул слишком много результатов. ",
  "catalogSelector.tooManyResults.text": "Повторите поиск с более конкретными ключевыми словами.",
  "catalogSelector.errorAlert": "Что-то пошло не так. Повторите попытку.",
  "catalogSelector.searchPlaceholder.byItem": "Поиск определенного продукта.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "Выберите определенные бренды или категории для продвижения.",
  "catalogSelector.checkAllItems.label": "Выбрать все",
  "catalogSelector.showAllSelections.label": "Показать только выбранные позиции.",
  "catalogSelector.cancelBtn.label": "Закрыть",
  "catalogSelector.saveBtn.label": "Применить и сохранить",
  "catalogSelector.brands.plural.zero": "Брендов: {number}",
  "catalogSelector.brands.plural.one": "Брендов: {number}",
  "catalogSelector.brands.plural.two": "Брендов: {number}",
  "catalogSelector.brands.plural.few": "Брендов: {number}",
  "catalogSelector.brands.plural.many": "Брендов: {number}",
  "catalogSelector.brands.plural.other": "Брендов: {number}",
  "catalogSelector.category.plural.zero": "Категорий: {number}",
  "catalogSelector.category.plural.one": "Категорий: {number}",
  "catalogSelector.category.plural.two": "Категорий: {number}",
  "catalogSelector.category.plural.few": "Категорий: {number}",
  "catalogSelector.category.plural.many": "Категорий: {number}",
  "catalogSelector.category.plural.other": "Категорий: {number}",
  "catalogSelector.product.plural.zero": "Продуктов: {number}",
  "catalogSelector.product.plural.one": "Продуктов: {number}",
  "catalogSelector.product.plural.two": "Продуктов: {number}",
  "catalogSelector.product.plural.few": "Продуктов: {number}",
  "catalogSelector.product.plural.many": "Продуктов: {number}",
  "catalogSelector.product.plural.other": "Продуктов: {number}",
  "confirmNavDialog.discardChanges.text": "Обязательно сохраните внесенные изменения. Если вы уйдете с этой страницы, все несохраненные изменения будут потеряны.",
  "confirmNavDialog.approveBtn.label": "OK",
  "confirmNavDialog.cancelBtn.label": "Отменить",
  "actionDashboard.overviewLinkText.referral": "Перейти к реферальным акциям",
  "actionDashboard.editLinkText": "Редактировать программу",
  "dashboardOptions.launchedAt": "Программа запущена в: ",
  "dashboardOptions.currentlyShowingLabel": "Сейчас показано:",
  "dashboardOptions.viewLabel": "Просмотреть:",
  "masterActions.join.largeText": "Присоединение к программе лояльности",
  "masterActions.purchases.largeText": "Покупка",
  "status.inactive.tooltip": "Эти настройки не завершены.",
  "status.inactive.tooltip.proomotionEnded": "Эта промоакция неактивна и не может быть отредактирована. Вы можете скопировать эту промоакцию или создать новую.",
  "status.inactive.tooltip.connectedToRewardPools": "Пул ваучеров {name} имеет статус {status}.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "Проверьте даты промоакции.",
  "status.readyToUse.tooltip.promotion": "Промоакция уже используется. Вы можете автоматически отобразить эту промоакцию в кошельке участника или прикрепить к участникам в редакторе кампаний с помощью маркеров лояльности.",
  "status.readyToUse.tooltip.attachable": "Эта акция уже используется и может быть прикреплена к контактам через редактор кампаний с помощью маркеров лояльности.",
  "status.active.tooltip.promotion": "Эта промоакция активна и доступна для участников.",
  "status.active.tooltip.attachable": "Эта акция активна. Вы не можете изменить настройки. Чтобы отредактировать эту акцию. сначала деактивируйте ее и дождитесь указанной даты истечения срока действия. Также можно скопировать акцию, отредактировать копию и запустить как новую акцию.",
  "status.active.tooltip.event": "Эта акция активна. Ее можно подключить к программе льгот или автоматизации.",
  "status.deactivated.tooltip.promotion": "Вы деактивировали эту промоакцию, и она больше не доступна участникам.",
  "status.deactivated.tooltip.attachable": "Вы деактивировали эту акцию. Чтобы отредактировать или удалить ее, дождитесь указанной даты истечения срока действия. Также можно скопировать акцию, отредактировать копию и запустить как новую акцию.",
  "editorTypePopup.title": "Выберите тип редактора",
  "editorTypePopup.text": "Клиенты без эксклюзивного доступа будут видеть страницу блокировки. Вы можете создать настраиваемую HTML-страницу или использовать один из наших шаблонов.",
  "editorTypePopup.options.html.text": "Создать настраиваемую HTML-страницу",
  "editorTypePopup.options.template.text": "Создать страницу из шаблона",
  "fileInputField.uploadBtn.label": "Загрузить",
  "fileInputField.browseBtn.label": "Обзор",
  "formStepsContainer.nextStep.text": "Следующий шаг",
  "formStepsContainer.prevStep.text": "Предыдущий шаг",
  "iconGallery.title": "Галерея значков лояльности",
  "iconGallery.deleteDialog.headline": "Действительно удалить этот значок?",
  "iconGallery.deleteDialog.content": "После удаления этого значка он не будет отображаться для участников. Убедитесь, что этот значок не подключен ни к одной акции или ваучеру.",
  "iconGallery.uploadResult.successMessage": "Загрузка выполнена успешно.",
  "iconGallery.searchInput.placeholder": "Поиск значка по имени.",
  "iconGallery.fileUploader.tooltip": "<h3>Загрузить</h3><b>Требования для загрузки значка:</b></br>Файл: SVG или PNG</br>Формат: квадратный<br>Макс. размеры: 200x200 пикс. <br>Макс. размер файла: 100 КБ</br><sub>* Мы рекомендуем прозрачный фон </sub>.",
  "multiLangPopup.defaultNoticeText": "Определенный вами основной язык является языком отображения по умолчанию для участников, если настройки подходящего языка отсутствуют.",
  "multiLangPopup.defaultTitle.currency": "Пересчет валют",
  "multiLangPopup.defaultTitle.language": "Перевод языков",
  "multiMarketSelector.multiSelectField.placeholder": "-- Выберите рынки --",
  "multiMarketSelector.selectField.placeholder": "-- Выберите рынок --",
  "multiPlanSelect.label": "Выберите свой план лояльности ",
  "preLaunchPopup.conditions.plan.title": "Настройки плана",
  "preLaunchPopup.conditions.plan.text": "Проверьте правильность настроек плана лояльности и соответствие условиям для участников.",
  "preLaunchPopup.conditions.tiers.title": "Уровни и льготы",
  "preLaunchPopup.conditions.tiers.text": "Проверьте правильность настроек уровней для всех участников и соответствие распределения контактов вашей стратегии.",
  "preLaunchPopup.conditions.rewards.title": "Пулы вознаграждений",
  "preLaunchPopup.conditions.rewards.text": "Проверьте достаточность загруженных кодов ваучеров для всех ответов и правильность определения сроков действия всех пулов и ваучеров.",
  "preLaunchPopup.conditions.actions.title": "Акции",
  "preLaunchPopup.conditions.actions.text": "Убедитесь, что акции покрывают все используемые тактики и все акции по умолчанию активированы.",
  "preLaunchPopup.title": "Действительно запустить план лояльности?",
  "preLaunchPopup.text": "Проверьте настройки, чтобы убедиться в готовности плана лояльности к запуску:",
  "timeValidityInput.radioLabel.days": "Дни",
  "timeValidityInput.radioLabel.weeks": "Недели",
  "timeValidityInput.radioLabel.months": "Месяцы",
  "ctaUrl": "URL-адрес CTA",
  "ctaText": "Текст CTA",
  "message": "Сообщение",
  "pageNotFound": "Не удается найти страницу, которую вы ищете.",
  "externalEventSetup.title": "Внешнее событие лояльности",
  "externalEventSetup.name.label": "Имя внешнего события",
  "externalEventSetup.description.label": "Описание",
  "externalEventSetup.description.tooltip": "Описание является внутренним и помогает управлять событиями лояльности.",
  "pointsRatesFields.perDescriptor.points": "заработано за",
  "catalog.item.type.category.name": "Категория",
  "catalog.item.type.brand.name": "Бренд",
  "catalog.item.type.item.name": "Продукт",
  "catalog.item.type.itemId.name": "Ид. позиции",
  "exclusiveAccessOffers.options.fixedBenefit.title": "Доступ как фиксированная льгота",
  "exclusiveAccessOffers.options.additionalBenefits.title": "Доступ как дополнительная льгота",
  "exclusiveAccessOffers.options.action.title": "Доступ как вознаграждение за действие",
  "exclusiveAccessOffers.options.redemption.title": "Доступ за баллы",
  "exclusiveAccessOffers.options.redemptionForFree.title": "Бесплатный доступ",
  "accessValidityType.options.unlimited.name": "Доступ действует неограниченное время.",
  "accessValidityType.options.limitedFromEarn.name": "Доступ действует ограниченное время с момента его получения участником.",
  "accessValidityType.options.fixedDate.name": "Доступ действует предварительно определенное время для всех пользователей.",
  "accessValidityType.options.disabled.fixedBenefit.name": "Отключить предоставление доступа в качестве фиксированной льготы.",
  "accessValidityType.options.disabled.additionalBenefit.name": "Отключить предоставление доступа в качестве дополнительной льготы.",
  "accessValidityType.options.disabled.reward.name": "Отключить предоставление доступа в качестве вознаграждения за действие.",
  "createOfModify.options.create.name": "Активировать предложение",
  "createOfModify.options.create.tooltip": "При активации нового предложения правила активного предложения сбрасываются и доступны участникам всех выбранных уровней в течение определенного периода действия предложения.",
  "createOfModify.options.create.tooltip2": "При активации нового предложения ограничения активного предложения сбрасываются и доступны участникам всех выбранных уровней в речение определенного периода действия предложения. ",
  "createOfModify.options.modify.name": "Редактировать активное предложение",
  "createOfModify.options.modify.tooltip": "При редактировании активного предложения ваши изменения не затрагивают участников, которые уже погасили это предложение.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "Настройки эксклюзивности",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "Страница блокировки",
  "exclusiveAccessFormSteps.redemptionValue.title": "Доступ и предложения",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "Активация",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "Расходные {{points_name}}",
  "activityElementPointsText.status": "Статусные {{points_name}}",
  "activityElementPointsText.cashback": "Кешбэк",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "Разовый ваучер",
  "voucherTypeText.yearly": "Многоразовый ваучер",
  "exclusiveAccessTypeText.permanent": "Постоянный эксклюзивный доступ",
  "exclusiveAccessTypeText.limitedTerm": "Эксклюзивный доступ на ограниченное время",
  "mainTabs.dashboard.title": "Информационная панель",
  "mainTabs.actions.title": "Акции",
  "mainTabs.rewards.title": "Вознаграждения",
  "mainTabs.tiers.title": "Уровни",
  "mainTabs.loyaltyWallet.title": "Кошелек лояльности",
  "mainTabs.memberProfiles.title": "Профили участников",
  "mainTabs.externalEvents.title": "Внешние события",
  "mainTabs.planSettings.title": "Настройки плана",
  "mainTabs.vouchers.title": "Ваучеры",
  "mainTabs.exclusiveAccesss.title": "Эксклюзивный доступ",
  "mainTabs.loyaltyManagement.title": "Управление лояльностью",
  "mainTabs.security.title": "Конфигурация лояльности",
  "actionTabs.purchases.title": "Покупки",
  "actionTabs.promotions.title": "Промоакции",
  "actionTabs.engagements.title": "Вовлечение",
  "actionTabs.events.title": "События",
  "actionTabs.referral.title": "Рекомендация",
  "actionTabs.join.title": "Присоединение к программе лояльности",
  "tierTabs.tiers.title": "Уровни",
  "tierTabs.fixedBenefits.title": "Фиксированные льготы",
  "tierTabs.additionalBenefits.title": "Дополнительные льготы",
  "tierTabs.contactDistribution.title": "Диаграмма распределения",
  "managementTabs.accountSettings.title": "Настройки учетной записи",
  "managementTabs.languageAndCurrency.title": "Язык и валюта",
  "managementTabs.planSettings.title": "Настройки плана",
  "managementTabs.cashbackSettings.title": "Настройки кешбэка",
  "managementTabs.membershipSettings.title": "Настройки участия",
  "managementTabs.updateAndLaunch.title": "Обновить и запустить",
  "onboardingTabs.accountSettings.title": "Создание плана",
  "onboardingTabs.activation.title": "Активация",
  "customerCalcPeriod.options.1.name": "Последние 30 дней",
  "customerCalcPeriod.options.2.name": "Последние 60 дней",
  "customerCalcPeriod.options.3.name": "Последние 90 дней",
  "customerCalcPeriod.options.6.name": "Последние 6 месяцев",
  "customerCalcPeriod.options.12.name": "Последние 12 месяцев",
  "planType.options.points.name": "Баллы и погашение",
  "planType.options.points_and_benefits.name": "Баллы и льготы",
  "planType.options.spend.name": "Расходы и льготы",
  "planType.options.points.tooltip": "План на основе баллов с одним или несколькими уровнями и погашением баллов.",
  "planType.options.points_and_benefits.tooltip": "План на основе баллов с несколькими уровнями и льготами без погашения баллов.",
  "planType.options.spend.tooltip": "План на основе расходов с одним или несколькими уровнями без баллов, но с правилами опции кешбэка. В плане на основе расходов действует только одна валюта. Если вы оперируете несколькими валютами, необходим отдельный план для каждой валюты.",
  "pointsAllocatopmDelay.options.1.name": "24 часа",
  "pointsAllocatopmDelay.options.2.name": "48 часов",
  "pointsAllocatopmDelay.options.3.name": "72 часа",
  "pointsAllocatopmDelay.options.7.name": "7 дней",
  "pointsAllocatopmDelay.options.14.name": "14 дней",
  "pointsAllocatopmDelay.options.21.name": "21 день",
  "pointsAllocatopmDelay.options.30.name": "30 дней",
  "pointsAllocatopmDelay.options.40.name": "40 дней",
  "tierCalculationType.options.endOfYear.name": " Расчет уровня происходит 31 декабря каждые [X лет].",
  "tierCalculationType.options.endOfYear.tooltip": "Уровни рассчитываются в фиксированную дату каждые [x лет]. Участники, переводимые на более высокий уровень, сохраняют свой статус уровня в течение определенного периода.",
  "tierCalculationType.options.afterJoin.name": "Расчет уровня выполняется через [X мес.] от даты перехода участника на уровень.",
  "tierCalculationType.options.afterJoin.tooltip": "Дата расчета уровня может варьироваться в зависимости от продвижения участника по уровням. Участники, переводимые на более высокий уровень, сохраняют свой статус уровня как минимум в течение определенного периода.",
  "tierCalculationType.options.endOfYear.spend.tooltip": "При расчете уровня кредит лояльности сбрасывается, но участники сохраняют свой статус уровня до следующего расчета.",
  "tierCalculationType.options.noDropout.name": "Уровни не рассчитываются. Участникам не требуется соответствовать требованиям, чтобы оставаться на этом уровне.",
  "tierCalculationType.options.noDropout.tooltip": "Баллы копятся только для повышения уровней.",
  "statusPointsExpirationType.options.tierCalc.name": "Статусные баллы прекращают действовать и сбрасываются в дату расчета уровня.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "При расчете баллов они сбрасываются, но участники сохраняют свой статус уровня до следующего расчета.",
  "statusPointsExpirationType.options.fromEarn.name": "Статусные баллы истекают и сбрасываются каждые [X мес.] с даты их получения участником.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "При расчете уровней рассчитываются только баллы, действительные на текущую дату. Участники сохраняют свой статус или переводятся на более низкий уровень.",
  "statusPointsExpirationType.options.never.name": "Срок действия статусных баллов никогда не истекает.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "Кредит лояльности истекает и сбрасывается в дату расчета уровней.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "При расчете кредита лояльности он сбрасывается, но участники сохраняют свой статус уровня до следующего расчета.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "Кредит лояльности истекает и сбрасывается каждые [X мес.] с даты его получения участником.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "При расчете уровней рассчитывается только кредит лояльности, действительный на текущую дату. Участники сохраняют свой статус или переводятся на более низкий уровень.",
  "optIn.options.invitation.name": "Все контакты приглашаются присоединиться к плану лояльности.",
  "optIn.options.automatic.name": "Все контакты автоматически становятся участниками плана лояльности.",
  "historicalBalancePoints.options.keep.name": "Вознаграждать расходными баллами.",
  "historicalBalancePoints.options.keep.tooltip": "Эта опция стимулирует участников погашать баллы за вознаграждения.",
  "historicalBalancePoints.options.remove.name": "Не вознаграждать расходными баллами.",
  "historicalBalancePoints.options.remove.tooltip": "Расходные баллы сбрасываются и участники должны заработать новые баллы для погашения.",
  "currencyIdentifierSigh.options.symbol.name": "Символ валюты",
  "currencyIdentifierSigh.options.symbol.tooltip": "Пример: $500",
  "currencyIdentifierSigh.options.code.name": "Код валюты ISO",
  "currencyIdentifierSigh.options.code.tooltip": "Пример: 500USD",
  "currencyIdentifierSigh.options.none.name": "Без идентификатора",
  "formStepRewards.options.poolSettings.title": "Настройки пула",
  "formStepRewards.options.uploadFile.title": "Загрузить файл",
  "formStepRewards.options.redemptionValue.title": "Настройки предложения",
  "formStepRewards.options.validity.title": "Срок действия",
  "specialTiers.redemptopmSettings.all.name": "Использовать одинаковые настройки для всех уровней. Индивидуальные значения уровней переопределяются.",
  "voucherValidityType.options.unlimited.name": "Ваучер действует неограниченное время.",
  "voucherValidityType.options.limitedFromEarn.name": "Ваучер действует ограниченное время с момента его получения участником.",
  "voucherValidityType.options.fixedDate.name": "Ваучер действует предварительно определенное время для всех пользователей.",
  "redemptionLimit.options.noLimit.name": "Автоматически показывать это предложение участникам на регулярной основе.",
  "redemptionLimit.options.noLimit.tooltip": "Если для уровня установить этот переключатель, предложение погашения отображается в кошельке лояльности без ограничений погашения.",
  "redemptionLimit.options.limitMember.name": "Выберите, сколько раз каждый участник может погасить ваучер в течение периода времени, определенного для этого предложения.",
  "exclusiveAccessExclusivityType.options.name.fixed": "Постоянная эксклюзивность",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "Эксклюзивность на ограниченный срок",
  "exclusiveAccessExclusivityType.options.name.limited": "Ограниченная эксклюзивность",
  "editorContentTextDefaultValues.tag": "Эксклюзивный доступ",
  "editorContentTextDefaultValues.firstHeader": "<strong>Ранняя \"черная пятница\"</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>РАСПРОДАЖА</strong>",
  "editorContentTextDefaultValues.middleText": "Эксклюзивные предложения \"черной пятницы\" для наших лояльных участников. Не пропустите. Присоединяйтесь к плану лояльности сейчас!",
  "editorContentTextDefaultValues.actionTopText": "Вы еще не с нами? Присоединяйтесь к плану лояльности и начните зарабатывать вознаграждения.",
  "editorContentTextDefaultValues.leftButton": "Присоединение к программе лояльности",
  "editorContentTextDefaultValues.rightButton": "В другой раз",
  "editorContentTextDefaultValues.actionBottomText": "<span>Уже участвуете? <u>Входите</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "Эксклюзивные предложения для наших лояльных клиентов. Не пропустите. Присоединяйтесь к нашему плану лояльности сейчас!",
  "editorContentTextDefaultValues.actionTopText.mobile": "Вы еще не с нами? Присоединяйтесь к нашей программе лояльности.",
  "accessUrlType.options.exactUrl.name": "Блокировать и предлагать эксклюзивный доступ к этой странице.",
  "accessUrlType.options.startsWithUrl.name": "Блокировать и предлагать эксклюзивный доступ ко всем страницам с URL-адресами, начинающимися с:",
  "formStepsContainer.tierSettings.title": "Настройки уровня",
  "formStepsContainer.purchaseBenefits.title": "Льготы на покупку",
  "formStepsContainer.visibility.title": "Видимость",
  "tierDropout.options.yes.name": "Да. этот уровень рассчитывается, и участники должны отвечать требованиям, чтобы оставаться на этом уровне.",
  "tierDropout.options.no.name": "Нет. этот уровень не предусматривает понижения.",
  "fixedBenfitType.options.oneTimeVoucher.name": "Разовый ваучер",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "Фиксированный ежегодный ваучер (требуется код многоразового использования).",
  "fixedBenfitType.options.eventAction.name": "Событие",
  "fixedBenfitType.options.exclusiveAccess.name": "Эксклюзивный доступ",
  "fixedBenfitType.options.custom.name": "Настраиваемый (независимо предоставляется вами)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "Многоразовый ваучер (требуется код многоразового использования).",
  "tierTypeOptions.regular.name": "На основе баллов",
  "tierTypeOptions.invite.name": "Только по приглашениям",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "Узнать больше",
  "tierTypeOptions.invite.tooltip": "На этом уровне могут находиться только приглашенные или платные участники. Управляйте оплатой и участием на своей стороне. Для добавления участников на этот уровень используйте Loyalty API или профили участников. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "На основе расходов",
  "exclusiveAccess.cardLabels.permanent": "Постоянный",
  "exclusiveAccess.cardLabels.limtedTerm": "С ограниченным сроком действия",
  "cards.filterBar.moreFiltersButton": "Больше фильтров",
  "catalogSelector.selected.single": "{items} выбрано",
  "catalogSelector.selected.multiple": "{items} и {lastItems} выбраны",
  "iconGallery.uploadResult.failMessage": "Что-то пошло не так во время загрузки. Убедитесь, что файлы соответствуют требованиям. \n{showFileList,select,true{{failed} out of {total} failed: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "для кажд.",
  "activityElementMultiuplyPointsText.double": "Двойн.",
  "activityElementMultiuplyPointsText.triple": "Тройн."
}
